import { useEffect, useState } from "react";

const hoja_ID = '1E8hxSq1m9eXBF9Wv9LYroqqI2AVFAMMAUVW5H-wGKQw';
const API_KEY = 'AIzaSyAxbiDA0NCbF7tKLZFAhLWdT3gj8Cp4YTQ';

export function useFetch(hojas = []){
    const [data,setdata] = useState({});
    const [cargando,setCargando] = useState(true);
    const [error,setError] = useState(null);



    useEffect(()=>{
        async function fetchData() {
            setCargando(true);
            const nuevaData = {};
            
            try {
                for(let hoja of hojas){
                    const url = `https://sheets.googleapis.com/v4/spreadsheets/${hoja_ID}/values/${hoja}?key=${API_KEY}`;
                    const res = await fetch(url);
                    if (!res.ok) throw new Error(`error en hoja ${hoja}`);
                    const json = await res.json();
                    nuevaData[hoja] = json.values;
                }
                setdata(nuevaData);
            } catch (error) {
                console.log(error);
                setError(error.message);
            } finally{
                setCargando(false);
            }
        }
        fetchData();

    },[hojas]);
    return {data, cargando,error}
}